import { useCallback, useEffect, useState } from 'react';
import { fetchRecommendedCarsApi } from '@/api/carApi';
import { RecommendedCarData } from '@/types/api/recommendedCarApi';

interface UseRecommendedCarsProps {
  tStockCarId: number | undefined;
}

export const useRecommendedCars = ({
  tStockCarId,
}: UseRecommendedCarsProps) => {
  const [data, setData] = useState<RecommendedCarData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!tStockCarId) return;

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const response = await fetchRecommendedCarsApi(tStockCarId);
      const { data: resData } = response as unknown as {
        data: {
          data?: RecommendedCarData;
          success: boolean;
          error_message?: string;
        };
      };

      if (resData?.success && resData.data) {
        setData(resData.data);
      } else {
        setErrorMessage(
          resData?.error_message ?? 'おすすめ車種の取得に失敗しました',
        );
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('おすすめ車種の取得に失敗しました');
    } finally {
      setIsLoading(false);
    }
  }, [tStockCarId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, isLoading, errorMessage } as const;
};
